import React, { Component, Fragment, pureComponent } from 'react';
import { inject, observer } from 'mobx-react';

@inject('lineStore', 'dictStore')
@observer
export default class Message extends Component {
  render() {
    const { globalError } = this.props.lineStore.basket.basketData;
    const { getLang } = this.props.dictStore;
    return (
      <div className="basket-result-cont">
        <div className="basket-error basket-error-red-new">
          <div className="basket-error-red-info-ico-new">!</div>
          <div
            className="basket-error-red-info-text-new"
            dangerouslySetInnerHTML={{ __html: getLang(globalError) }}
          />
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/basket/message.js